import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { UserProvider, useUser } from './context/UserContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import StudentDetail from './pages/StudentDetail';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Lecturers from './pages/Lecturers';
import Finance from './pages/Finance';
import Communication from './pages/Communication';
import Leads from './pages/Leads';
import LeadDetail from './pages/LeadDetail';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Schedule from './pages/Schedule';
import Tasks from './pages/Tasks';
import Prospects from './pages/Prospects';
import ProspectDetail from './pages/ProspectDetail';
import Accounting from './pages/Accounting';
import PaymentPage from './pages/PaymentPage';
import SignPage from './pages/SignPage';
import RegistrationForm from './pages/RegistrationForm';
import RegistrationForms from './pages/RegistrationForms';
// LecturerPortal is intentionally kept in the project but disconnected from routing —
// the system is now for administrative staff only. Re-import to re-enable.
// import LecturerPortal from './pages/LecturerPortal';
import './App.css';

function AppRoutes() {
  const location = useLocation();
  const { isLoggedIn } = useUser();

  // Public routes - no auth required, no layout
  if (location.pathname.startsWith('/pay/')) {
    return <Routes><Route path="/pay/:paymentLinkId" element={<PaymentPage />} /></Routes>;
  }
  if (location.pathname.startsWith('/sign/')) {
    return <Routes><Route path="/sign/:signatureId" element={<SignPage />} /></Routes>;
  }
  if (location.pathname.startsWith('/register/')) {
    return <Routes><Route path="/register/:registrationId" element={<RegistrationForm />} /></Routes>;
  }

  if (!isLoggedIn) {
    return <Login />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/students" element={<Students />} />
        <Route path="/students/:id" element={<StudentDetail />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:id" element={<CourseDetail />} />
        <Route path="/lecturers" element={<Lecturers />} />
        <Route path="/finance" element={<Finance />} />
        <Route path="/communication" element={<Communication />} />
        <Route path="/prospects" element={<Prospects />} />
        <Route path="/prospects/:id" element={<ProspectDetail />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/leads/:id" element={<LeadDetail />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/accounting" element={<Accounting />} />
        <Route path="/registration-forms" element={<RegistrationForms />} />
      </Routes>
    </Layout>
  );
}

function AppContent() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

function App() {
  return (
    <LanguageProvider>
      <UserProvider>
        <AppContent />
      </UserProvider>
    </LanguageProvider>
  );
}

export default App;
